import React  from 'react';

export default function renderColorGroupTListHeader2(id, props) {

    if (_.isNil(props.data.value)) {
        return <div className="text ui5-txt-default">Not selected</div>
    }

    return <div className={Classes("ui5-color-picker gd-c-" + props.data.value)}/>
}